import gql from 'graphql-tag';

const GET_LOG_WINDOWS_ASSIGN = gql`
    query getlogWindowsAssign ($salesChannel: Int, $init: String, $end: String) {
        getlogWindowsAssign (salesChannel: $salesChannel, init: $init, end: $end) {
            internalCode
            payload {
                creationAt
                userId
                salesChannel
                windowStart
                windowEnd
                selectedSla
                courierName
                switchType
            }
        }
    }
`;

export default GET_LOG_WINDOWS_ASSIGN;